import React, { createContext, useReducer } from "react";
import { bulkUploadReducer, initialState } from "./bulkUploadReducer";

export const BulkUploadContext = createContext();

export const BulkUploadProvider = ({ children }) => {
  const [state, dispatch] = useReducer(bulkUploadReducer, initialState);

  return (
    <BulkUploadContext.Provider value={{ state, dispatch }}>
      {children}
    </BulkUploadContext.Provider>
  );
};
